module.exports = __webpack_public_path__ + "Roboto-Light-webfont.3581138bd3477ae13eca.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Light-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light-webfont.svg
// module chunks = styles